// assets/js/animations.js
import { gsap } from "gsap";

// Core plugins
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { Flip } from "gsap/Flip";
import { Observer } from "gsap/Observer";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";

// Text & SVG plugins
import { TextPlugin } from "gsap/TextPlugin";
import { SplitText } from "gsap/SplitText";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

// Physics / Extras
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { Physics2DPlugin } from "gsap/Physics2DPlugin";
import { PhysicsPropsPlugin } from "gsap/PhysicsPropsPlugin";

// Easings & utilities
import { CustomEase } from "gsap/CustomEase";
import { CustomBounce } from "gsap/CustomBounce";
import { CustomWiggle } from "gsap/CustomWiggle";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";

// Optional developer tools
import { GSDevTools } from "gsap/GSDevTools";
import { MotionPathHelper } from "gsap/MotionPathHelper";
import { PixiPlugin } from "gsap/PixiPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(
  ScrollTrigger,
  ScrollSmoother,
  ScrollToPlugin,
  Draggable,
  Flip,
  Observer,
  MotionPathPlugin,
  TextPlugin,
  SplitText,
  MorphSVGPlugin,
  DrawSVGPlugin,    
  InertiaPlugin,
  Physics2DPlugin,
  PhysicsPropsPlugin,
  CustomEase,
  CustomBounce,
  CustomWiggle,
  RoughEase,
  ExpoScaleEase,
  SlowMo,
  GSDevTools,
  MotionPathHelper,
  PixiPlugin,
  ScrambleTextPlugin,
  CSSRulePlugin,
);

// BUTTON DRAW IN ANIMATIONS
document.querySelectorAll(".gsap-border-btn").forEach((btn) => {
  if (btn.querySelector(".border-line")) return;

  const top = document.createElement("span");
  top.className = "border-line top";

  const bottom = document.createElement("span");
  bottom.className = "border-line bottom";

  btn.appendChild(top);
  btn.appendChild(bottom);

  const tl = gsap.timeline({
    paused: true,
    defaults: {
      duration: 0.4,
      ease: "linear", // IMPORTANT
    },
  });

  // Both draw at the same time
  tl.to(top, { width: "100%" }, 0)
    .to(bottom, { width: "100%" }, 0);

  btn.addEventListener("mouseenter", () => tl.play());
  btn.addEventListener("mouseleave", () => tl.reverse());

  btn.addEventListener("focus", () => tl.play());
  btn.addEventListener("blur", () => tl.reverse());
});
// BUTTON DRAW IN ANIMATIONS END

console.log("GSAP loaded", gsap.version);

document.addEventListener('DOMContentLoaded', () => {
    // VANTA.WAVES({
    // el: "#brxe-eehtnu",
    // mouseControls: true,
    // touchControls: true,
    // gyroControls: false,
    // minHeight: 200.00,
    // minWidth: 200.00,
    // scale: 1.00,
    // scaleMobile: 1.00,
    // color: 0x2c1842,
    // shininess: 51.00,
    // waveHeight: 15.50,
    // waveSpeed: 0.50,
    // zoom: 0.78
    // });
    VANTA.NET({
      el: "#brxe-eehtnu",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      scale: 1.00,
      scaleMobile: 1.00,
      color: 0x60dc6b,
      backgroundColor: 0x05012e,
      points: 8.00
    })
});

document.addEventListener("DOMContentLoaded", function () {

  const blocks = document.querySelectorAll("#brxe-vqixdz > .brxe-block");
  const wrapper = document.querySelector("#brxe-czdvqi");
  const originalImage = document.querySelector("#brxe-ravaau");

  if (!blocks.length || !wrapper || !originalImage) return;

  // Store original src
  const originalSrc = originalImage.src;
  const originalSrcset = originalImage.srcset;
  const originalSizes = originalImage.sizes;

  // Clone image to create crossfade pair
  const clone = originalImage.cloneNode(true);
  clone.classList.remove("is-top");
  clone.classList.add("is-bottom");

  originalImage.classList.add("is-top");

  wrapper.appendChild(clone);

  let activeTop = originalImage;
  let activeBottom = clone;

  function swapImage(newImg) {

    const newSrc = newImg ? newImg.src : originalSrc;
    const newSrcset = newImg ? newImg.srcset : originalSrcset;
    const newSizes = newImg ? newImg.sizes : originalSizes;

    if (activeTop.src === newSrc) return;

    // Update bottom image first
    activeBottom.src = newSrc;
    if (newSrcset) {
      activeBottom.srcset = newSrcset;
      activeBottom.sizes = newSizes;
    }

    // Crossfade
    activeBottom.style.opacity = 1;
    activeTop.style.opacity = 0;

    // Swap roles after animation
    setTimeout(() => {
      [activeTop, activeBottom] = [activeBottom, activeTop];
    }, 500);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        const img = entry.target.querySelector(".scroll-image");
        swapImage(img);
      }

    });
  }, {
    root: null,
    threshold: 0.8
  });

  blocks.forEach(block => observer.observe(block));

});

document.addEventListener("DOMContentLoaded", function() {

  const header = document.querySelector(".smart-header");
  const headerHeight = header.offsetHeight;

  let lastScroll = 0;

  window.addEventListener("scroll", function() {

    const currentScroll = window.pageYOffset;

    // When we scroll past header height → make sticky
    if (currentScroll > headerHeight) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
      header.classList.remove("is-visible");
    }

    // If not sticky yet, do nothing
    if (!header.classList.contains("is-sticky")) {
      lastScroll = currentScroll;
      return;
    }

    // Scroll down → hide
    if (currentScroll > lastScroll) {
      header.classList.remove("is-visible");
    } 
    // Scroll up → show
    else {
      header.classList.add("is-visible");
    }

    lastScroll = currentScroll;
  });

});

console.log("banner animation loaded");